import { useDispatch, useSelector } from "react-redux";

import { CategoryForm } from "./CategoryForm";
import { CreateCategory } from "../../redux/category";
import { ErrorBanner } from "../../components/banner";
import { Loading } from "../../components/loader";
import { Section } from "../../components/section";
import { useNavigate } from "react-router-dom";

export const CategoryCreate = () => {
  const dispatch = useDispatch();
  const { error, loading } = useSelector((state) => state.category);
  let navigate = useNavigate();

  const onFormSubmit = (values) => {
    if (window.confirm(`Are you sure you want to add this category?`)) {
      dispatch(CreateCategory(values));
    }

    if (!loading && !error) {
      setTimeout(() => {
        navigate("/categories");
      }, 500);
    }
  };

  if (loading) {
    return <Loading />;
  }
  return (
    <Section>
      {error && <ErrorBanner text={error} />}

      <CategoryForm onFormSubmit={onFormSubmit} />
    </Section>
  );
};
